import React from 'react';
import { TextBox } from '@kohler-dsm-library/kohler-core';

const TextArea = ({ label, name, value, onChange, onBlur, error, description }) => {
  const props = {
    id: name,
    label: label,
    hasBorder: true,
    showCounter: true,
    name: name,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    error: error,
    description: description,
  };

  return (
    <div className="col-12">
      <TextBox {...props} />
    </div>
  );
};

export default TextArea;
